<script>
  let toggleSignature = false;
  export let questionnaire;

  let toggleSignatureIcon = () => {
    toggleSignature = !toggleSignature;
  };
</script>

<!-- svelte-ignore missing-declaration -->
<div class="cuestionariocardcontainer">
  <div class="cuestionariocard headerid">
    <div class="cuestionarioitem">
      <div class="fieldlabelcuestionarios whitetext">ID Cuestionario</div>
      <div class="bodytextcuestionario inputmedium minmargin headerinput">
        {questionnaire.idInterno}
      </div>
    </div>
    <div class="div-block-13">
      <div class="cuestionarioitem">
        <div class="fieldlabelcuestionarios whitetext">Creación</div>
        <div class="bodytextcuestionario inputmedium minmargin headerinput">
          {moment(questionnaire.fechaCreacion).format("DD/MM/YYYY HH:mm:ss")}
        </div>
      </div>
      <div class="cuestionarioitem lastitem">
        <div class="fieldlabelcuestionarios whitetext">Cierre</div>
        <div class="bodytextcuestionario inputmedium minmargin headerinput">
          {moment(questionnaire.fechaCierre).format("DD/MM/YYYY HH:mm:ss")}
        </div>
      </div>
    </div>
  </div>
  <div class="cuestionariocard">
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Profesor/a</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire._profesorCod_}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire._profesor_}
      </div>
    </div>
    <!--     <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Área</div>
      <div class="bodytextcuestionario inputmedium minmargin">Código</div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        Nombre del Área
      </div>
    </div> -->
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Centro</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.centroCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.centro}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Departamento</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.departamentoCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.departamento}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Asignatura</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.asignaturaCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.asignatura}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Plan</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.planCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.plan}
      </div>
    </div>
    <div class="cardline listadocuestionarios">
      <div class="fieldlabelcuestionarios minmargin">Grupo de actividad</div>
      <div class="bodytextcuestionario inputmedium minmargin">
        {questionnaire.grupoCod}
      </div>
      <div class="bodytextcuestionario lastitem fullwidthresponsive">
        {questionnaire.grupo}
      </div>
    </div>
    <div class="cardline listadocuestionarios latitem">
      <div class="cuestionarioitem">
        <div class="fieldlabelcuestionarios minmargin widthauto">
          Nº alumnos presentes
        </div>
        <div class="bodytextcuestionario lastitem staticwidth">
          {questionnaire.numPresentes}
        </div>
      </div>
      <div class="cuestionarioitem">
        <div class="fieldlabelcuestionarios minmargin widthauto">
          Nº alumnos online
        </div>
        <div class="bodytextcuestionario lastitem staticwidth">
          {questionnaire.numOnline}
        </div>
      </div>
      <div class="cuestionarioitem lastitem">
        <div class="fieldlabelcuestionarios minmargin widthauto">
          Nº respuestas recibidas
        </div>
        <div class="bodytextcuestionario lastitem staticwidth">
          {questionnaire.numRespuestas}
        </div>
      </div>
    </div>
  </div>

  <div class="cuestionariocard firmaacta">
    <div
      class="cardline listadocuestionarios justifyaround toggleButton"
      on:click={() => {
        toggleSignatureIcon();
      }}
    >
      <div class="fieldlabelcuestionarios greentext firmaacta nomarginbottom">
        Firma del acta
      </div>
      <img
        src={!toggleSignature ? "images/down.svg" : "images/up.svg"}
        loading="lazy"
        height="20"
        alt=""
      />
    </div>
    {#if toggleSignature}
      <div class="mostrarocultar">
        <div class="cardline listadocuestionarios">
          <div class="fieldlabelcuestionarios minmargin firmaacta">
            Evaluador que firma el acta
          </div>
          <div class="bodytext inputmedium minmargin">
            {questionnaire._responsableDNI_}
          </div>
          <div class="bodytextcuestionario lastitem fullwidthresponsive">
            {questionnaire._responsable_}
          </div>
        </div>
        <div class="cardline listadocuestionarios">
          <div class="fieldlabelcuestionarios minmargin firmaacta">
            Profesor/a que firma el acta
          </div>
          <div class="bodytext inputmedium minmargin">
            {questionnaire._docenteDNI_}
          </div>
          <div class="bodytextcuestionario lastitem fullwidthresponsive">
            {questionnaire._docente_}
          </div>
        </div>
        <div class="cardline listadocuestionarios">
          <div class="fieldlabelcuestionarios minmargin firmaacta">
            Alumno/a que firma el acta
          </div>
          <div class="bodytext inputmedium minmargin">
            {questionnaire._alumnoDNI_}
          </div>
          <div class="bodytextcuestionario lastitem fullwidthresponsive">
            {questionnaire._alumno_}
          </div>
        </div>
        <div class="cardline listadocuestionarios">
          <div class="fieldlabelcuestionarios minmargin firmaacta">
            Incidencias
          </div>
        </div>
        {#if questionnaire.incidencias !== ""}
          <div class="cardline listadocuestionarios incidencias">
            <div class="bodytextcuestionario lastitem fullwidthresponsive">
              {questionnaire.incidencias}
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>

<style>
  .cuestionariocardcontainer {
    width: 100%;
  }

  .toggleButton {
    cursor: pointer;
  }

  div.mostrarocultar {
    width: 100%;
  }

  div.incidencias {
    width: 100%;
  }

  div.incidencias div {
    width: 100%;
    white-space: normal;
  }
</style>
